// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4pE1g","credentialsContainer":"styles_credentialsContainer__lda5x"};